import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID
};

const artistConfig = {
  apiKey: process.env.REACT_APP_ARTIST_API_KEY,
  authDomain: process.env.REACT_APP_ARTIST_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_ARTIST_PROJECT_ID,
  storageBucket: process.env.REACT_APP_ARTIST_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_ARTIST_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_ARTIST_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const artistApp = initializeApp(artistConfig, 'artists');

export const auth = getAuth(app);
export const artistAuth = getAuth(artistApp);
export const storage = getStorage(artistApp);
export const adminStorage = getStorage(app);



